const findUsedDRGInPolicy = (nodes) => {
    const usedDRGSet = new Set(
        nodes
            .filter(node => node.type === 'data')
            .map(node => node.data?.general_properties?.drg?.id)
            .filter(Boolean)
    );

    const arrayWithUsedDRG = [...usedDRGSet];

    return arrayWithUsedDRG;
};

export default findUsedDRGInPolicy;